module.exports = " <div class=\"country-admin section\"> <h1 class=title>Countries</h1> <div> <div class=media v-for=\"country in countries\"> <div class=media-left> <img v-bind:src=\"'/static/img/flags/'+country.en.name.replace(' ', '-')+'.png'\"/> </div> <h2 class=subtitle>{{country.en.name}}</h2> {{country |json}} </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Countries.vue
 ** module id = 42
 ** module chunks = 1
 **/